import React from "react"
import badge from "badges/alien-master.svg"
import { BadgeImage } from "backpack/badges/styled"

const AlienMaster = props => <BadgeImage src={badge} {...props} />

export default AlienMaster
